import _ from 'lodash';
import { createSelector } from 'reselect';

export const selectSharedZaps = state => state.sharedZap.sharedZaps;

export const selectSharedZapById = id =>
  createSelector(
    selectSharedZaps,
    sharedZaps => sharedZaps[id]
  );

export const isSharedZapLoaded = id =>
  createSelector(
    selectSharedZapById(id),
    sharedZap => !_.isUndefined(sharedZap) && !_.isNull(sharedZap)
  );

export const selectSharedZapSelectedApis = id =>
  createSelector(
    selectSharedZapById(id),
    sharedZap =>
      _.reduce(
        sharedZap.steps,
        (arr, step) =>
          step.type === 'node' ? arr.concat(step.selected_api) : arr,
        []
      )
  );
